export default "__VITE_ASSET__BQiQY$5i__"